import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  GetPrivateNumberPriceByIdDto,
  UpdatePrivateNumberPriceCommand,
} from 'src/app/core/api/models';
import { PrivateNumberPriceService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { CreatePrivateNumberPriceCommand } from './../../../../core/api/models/create-private-number-price-command';

@Component({
  selector: 'app-private-numbers-price-form',
  templateUrl: './private-numbers-price-form.component.html',
  styleUrls: ['./private-numbers-price-form.component.scss'],
  imports: [BaseFormModule],
})
export class PrivateNumbersPriceFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  currentService = inject(PrivateNumberPriceService);

  formPageConfig: FormPageConfig<GetPrivateNumberPriceByIdDto> = {};
  model: CreatePrivateNumberPriceCommand = {};

  //#endregion

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      isRound: new FormControl(''),
      isActive: new FormControl(''),
      numberOfDigits: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      reservationPeriod: new FormControl('', Validators.required),
      smsCp: new FormControl('', Validators.required),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateNumberPriceCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .privateNumberPriceCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePrivateNumberPriceCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .privateNumberPriceUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
